import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Alert icon component with circular background and exclamation mark
 */
export const AlertIcon: FC<Props> = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="22" height="22" rx="11" fill="currentColor" />
    <path
      d="M12 17.5V17.5001"
      fill="none"
      stroke="white"
      strokeWidth="3.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.95013V12.8251"
      fill="none"
      stroke="white"
      strokeWidth="3.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
